<template>
  <v-card>
    <v-card-title class="align-items-center d-flex justify-content-between pb-0 flex-nowrap">
      <span class="module-selection-title">Tem certeza de sua escolha?</span>
      <BtnClose @click="$emit('onClose')" />
    </v-card-title>
    <v-divider />
    <v-card-text 
      v-if="selectedBlocks.length > 0"
      class="pt-0 pb-0"
    >
      <p class="font-weight-bold mb-0">
        Conteúdo(s) com base na carreira:
      </p>
      <p>
        Carreira: {{ trail ? trail.name : '' }} <br> Bloco(s) selecionado(s):
      </p>
      <ConfirmSelectionCard
        v-for="(block, index) in selectedBlocks"
        :key="index"
        :title="block.name"
        :subtitle="block.description"
      />
    </v-card-text>

    <v-card-text class="pt-2 pb-4">
      <p class="font-weight-bold mb-0">
        Conteúdo(s) com base em seu desempenho nos simulados:
      </p>
      <p>
        Você escolheu esses módulos:
      </p>

      <ConfirmSelectionCard
        v-for="(module, index) in selectedSelectionModules"
        :key="index"
        :title="module.subject_name"
        :subtitle="module.name"
      />
       
      <p class="text-center mt-4 text-body-2">
        <i class="fas fa-exclamation-circle" />
        <b>Atenção:</b>  você não poderá alterar essa seleção depois.
      </p>
      <div class="d-flex justify-content-center w-100">
        <v-btn
          color="nitro"
          class="text-white px-4"
          @click.once="$emit('onConfirm')"
        >
          Continuar
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import BtnClose from "@/common/components/BtnClose";
import ConfirmSelectionCard from './ConfirmSelectionCard'
import { mapGetters } from "vuex";

export default {
  components:{ BtnClose, ConfirmSelectionCard },
  computed: {
    ...mapGetters([
      'selectedBlocks',
      'selectedSelectionModules',
      'selectedTrailId',
      'trails',
      'authUser',
    ]),
    trail() {
      return this.selectedTrailId ? this.trails.find(t => t.id == this.selectedTrailId) : this.authUser.current_trail;
    },


  },
}
</script>
<style scoped lang="scss">
.module-selection-title{
  @media screen and (max-width:768px) {
    font-size: 0.7em;
  }
}
</style>
